// Redux
import { useSelector, useDispatch } from 'react-redux';
import {
  setShowRoundDrawer,
  setSelectedRound,
} from '@Modal/reducers/rounds/drawer/minesRoundDrawerSlice';
// System
import { useSnackbar } from 'notistack';
// Graphql
import { useMinesRoundLazyQuery } from '@Src/generated.graphql';
// Types
import { AppDispatch } from 'src/app/store';
import { StoreInterface } from 'src/app/types';

export const useMinesRoundDrawer = () => {
  const [getRound] = useMinesRoundLazyQuery();
  const dispatch = useDispatch<AppDispatch>();

  const { showRoundDrawer, selectedRoundData } = useSelector(
    (state: StoreInterface) => state?.minesRoundDrawer
  );

  const { enqueueSnackbar } = useSnackbar();

  const handleRoundRowClick = async (id: string) => {
    try {
      const { data } = await getRound({ variables: { roundId: id } });
      if (data) {
        await dispatch(setSelectedRound(data?.minesRound));
        dispatch(setShowRoundDrawer(true));
      }
    } catch (error) {
      enqueueSnackbar(error, {
        autoHideDuration: 2000,
        variant: 'error',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
        },
      });
    }
  };

  return {
    // Store
    showRoundDrawer,
    selectedRoundData,
    // Actions
    setSelectedRound,
    setShowRoundDrawer,
    // Handlers
    handleRoundRowClick,
  };
};
